import type { TMessages } from '@/types/TMessages'

export const messages = { header: 'Кадрировать изображение', addImage: 'Добавить изображение', cancel: 'Отмена' } satisfies TMessages
